export function playSound(soundPath: string) {
    const snd = new Audio(soundPath);
    snd.play();
}
